module.exports = __webpack_public_path__ + "static/media/mettaSocialLogo.b20f9e8b.png";